import { render, staticRenderFns } from "./ResearcherClaimVersionReadOnly.vue?vue&type=template&id=2d346bb4&scoped=true&"
import script from "./ResearcherClaimVersionReadOnly.vue?vue&type=script&lang=js&"
export * from "./ResearcherClaimVersionReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d346bb4",
  null
  
)

export default component.exports